import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import Top from "../components/Top";
import Navbar from "../components/Navbar";

const Filters = ({ currentUser }) => {
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [filter, setFilter] = useState();

    const navigate = useNavigate();

    const inputRef = useRef();
    const greenInputRef = useRef();
    const amberInputRef = useRef();

    useEffect(() => {
        setPageLoading(true)
        const fetchFilter = async () => {
            let response = await axios.get(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/filter`,
                {
                    withCredentials: true
                })
            setFilter(response.data.filter)
            setPageLoading(false)
        }
        fetchFilter()
    }, [])

    if (pageLoading) {
        return <><ClipLoader className="absolute top-1/2 left-1/2 -translate-1/2" /></>
    }

    const handleQualificationPercentageEnter = (e) => {
        if (e.key === "Enter") {
            setLoading(true)
            const fetchCandidates = async () => {
                try {
                    const response = await axios.post(
                        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
                        }/api/v1/update-qualification-criterial`, { percentage: inputRef.current.value },
                        {
                            withCredentials: true
                        }
                    );
                    toast.success(response.data.message)
                    setLoading(false)
                } catch (error) {
                    setLoading(false)
                    toast.error(error.response.data.message)
                }
            };
            fetchCandidates();
        }
    }

    const handleQualificationPercentage = () => {
        setLoading(true)
        const fetchCandidates = async () => {
            try {
                const response = await axios.post(
                    `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
                    }/api/v1/update-qualification-criterial`, { percentage: inputRef.current.value },
                    {
                        withCredentials: true
                    }
                );
                toast.success(response.data.message)
                setLoading(false)
            } catch (error) {
                setLoading(false)
                toast.error(error.response.data.message)
            }
        };
        fetchCandidates();
    }

    const handleGradingColor = () => {
        setLoading2(true)
        const fetchCandidates = async () => {
            try {
                const response = await axios.post(
                    `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
                    }/api/v1/update-grading-color`, { green: greenInputRef.current.value, amber: amberInputRef.current.value },
                    {
                        withCredentials: true
                    }
                );
                toast.success(response.data.message)
                setLoading2(false)
            } catch (error) {
                setLoading2(false)
                toast.error(error.response.data.message)
            }
        };
        fetchCandidates();
    }

    return (
        <div className="py-6 px-3 xl:px-8 sm:px-5">
            <Top currentUser={currentUser} />
            <Navbar currentUser={currentUser} />
            <div className="bg-white rounded-lg px-0 xl:px-8 sm:px-6 p-8 w-full sm:w-[450px] xl:w-[520px] mx-auto">
                <h2 className=" font-semibold text-[18px] sm:text-[20px] xl:text-[24px] 2xl:text-[26px] leading-none tracking-normal text-[#5D0E23]">
                    Qualification Criteria
                </h2>

                <div
                    className=" flex flex-col gap-2"
                >
                    <div className="mb-1">
                        <input
                            aria-label="Qualification percentage"
                            onKeyDown={handleQualificationPercentageEnter}
                            ref={inputRef}
                            className={`mt-[2px] text-[12px] sm:text-[14px] xl:text-[16px] appearance-none border border-[#797979] rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  `}
                            placeholder={filter[0]?.qualification_p}
                        />
                        <p className="text-xs">Qualifying score for skill assessment.</p>
                    </div>

                    <div className="flex items-center justify-center">
                        <button
                            onClick={handleQualificationPercentage}
                            type="submit"
                            className="cursor-pointer  font-semibold text-[16px] xl:text-[14px] rounded-[6px] xl:rounded-[6px] mt-1 2xl:mt-2  2xl:rounded-[8px] xxl:rounded-[10px] 2xl:text-[20px] xxl:text-2xl leading-none tracking-normal bg-[#7F132F] px-8 hover:bg-[#55051A] text-white py-[10px] focus:outline-none "
                        >
                            {loading ? (
                                <ClipLoader size={"1em"} color="white" />
                            ) : (
                                "Apply"
                            )}
                        </button>
                    </div>
                </div>
            </div>
            <div className="bg-white rounded-lg px-0 xl:px-8 sm:px-6 p-8 pt-0 w-full sm:w-[450px] xl:w-[520px] mx-auto">
                <h2 className=" font-semibold text-[18px] sm:text-[20px] xl:text-[24px] 2xl:text-[26px] leading-none tracking-normal text-[#5D0E23]">
                    Skill Based Assessment Color Scheme
                </h2>

                <div
                    className=" flex flex-col gap-0"
                >
                    <div className="mb-2 pt-[6px]">
                        <label className="text-sm flex items-center gap-2" htmlFor="">Green <span className="w-[80px] h-[2px] bg-[#00D076] block"></span></label>
                        <input
                            aria-label="Green score threshold"
                            ref={greenInputRef}
                            className={`mt-0 text-[10px] sm:text-[12px] xl:text-[14px] appearance-none border border-[#797979] rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  `}
                            placeholder={filter[0]?.green}
                        />
                        <p className="text-xs">Progress bar displays green from set skill level to 100.</p>
                    </div>
                    <div className="mb-3 pt-[6px]">
                        <label className="text-sm flex items-center gap-2" htmlFor="">Amber <span className="w-[80px] h-[2px] bg-[#FFD335] block"></span></label>
                        <input
                            aria-label="Amber score threshold"
                            ref={amberInputRef}
                            className={`mt-0 text-[10px] sm:text-[12px] xl:text-[14px] appearance-none border border-[#797979] rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  `}
                            placeholder={filter[0]?.amber}
                        />
                        <p className="text-xs">Progress bar shows amber from set skill level up to Green; values below show Red.</p>
                    </div>

                    <div className="flex items-center justify-center">
                        <button
                            onClick={handleGradingColor}
                            type="submit"
                            className="cursor-pointer  font-semibold text-[16px] xl:text-[14px] rounded-[6px] xl:rounded-[6px] mt-1 2xl:mt-2  2xl:rounded-[8px] xxl:rounded-[10px] 2xl:text-[20px] xxl:text-2xl leading-none tracking-normal bg-[#7F132F] px-8 hover:bg-[#55051A] text-white py-[10px] focus:outline-none "
                        >
                            {loading2 ? (
                                <ClipLoader size={"1em"} color="white" />
                            ) : (
                                "Apply"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Filters;
